<section class="parallax_blog" [style.background-image]="heroImage">
  <div class="caption">
    <span class="border display-5 fw-bold">{{ article?.title || (notFound ? 'Article not found' : '') }}</span>
  </div>
</section>

<main class="article-page">
  <!-- Loading -->
  <div class="container narrow" *ngIf="loading" aria-busy="true">
    <span class="sk sk-title"></span>
    <span class="sk sk-line w-40"></span>
    <span class="sk sk-cover"></span>
    <span class="sk sk-line"></span>
    <span class="sk sk-line w-80"></span>
  </div>

  <!-- Not found -->
  <div class="container narrow state" *ngIf="!loading && notFound">
    <p>This article may have been moved or unpublished.</p>
    <a routerLink="/blog" class="btn-outline">Browse all articles</a>
  </div>

  <ng-container *ngIf="!loading && article">
    <article>
      <header class="container narrow article-head">
        <a routerLink="/blog" class="back"><i class="fa-solid fa-arrow-left"></i> All articles</a>
        <h1 class="visually-hidden">{{ article.title }}</h1>
        <p class="lede" *ngIf="article.excerpt">{{ article.excerpt }}</p>
        <p class="byline">
          <span *ngIf="article.category" class="cat">{{ article.category }}</span>
          <span *ngIf="article.author_name">By {{ article.author_name }}</span>
          <span>{{ articleService.formatDate(article.published_at) }}</span>
          <span>{{ article.reading_minutes }} min read</span>
        </p>
      </header>

      <div class="container narrow">
        <div class="prose" [innerHTML]="article.content"></div>
      </div>
    </article>

    <aside class="related" *ngIf="related.length" aria-labelledby="related-title">
      <div class="container">
        <h2 id="related-title">More stories</h2>
        <div class="related-grid">
          <a class="related-item" *ngFor="let item of related" [routerLink]="['/blog', item.slug]">
            <div class="related-media">
              <img [src]="articleService.coverUrl(item)" [alt]="item.title" loading="lazy">
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ articleService.formatDate(item.published_at) }} · {{ item.reading_minutes }} min read</p>
          </a>
        </div>
      </div>
    </aside>
  </ng-container>
</main>

<app-smartch></app-smartch>
<app-review></app-review>
<app-review-b></app-review-b>
<app-footer></app-footer>
